module.exports = __webpack_public_path__ + "static/media/pago5.e6a06628.svg";